import axiosInstance from "@/utils/axiosInstance";

const baseUrl = `api/public/cgu`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getCguTemplate({commit}, payload: { language: string }) {
    return axiosInstance.get(`${baseUrl}`, {params: {language: payload.language}})
    .then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
